import MainComponent from "components/Main";

import Button from "components/Button";
import ButtonIconSelect from "components/ButtonIconSelect";
import ButtonIcon from "components/ButtonIcon";
import Table from "components/Table";

import './index.less';
import './themes/default.less';

import { ReactComponent as PlusIcon } from 'icons/buttons/plus.svg';
import { ReactComponent as UploadIcon } from 'icons/components/upload.svg';

import './themes/default.less';
import './index.less';

export default class PriceLists extends MainComponent {

    constructor(props) {
        super(props);

        this.tableMap = {
            validity: {
                label: "price.validity",
            },
            status: {
                label: "main.status",
                callback: this.renderStatusCell.bind(this),
            },
            createdName: {
                label: "main.createBy",
            },
            comment: {
                label: "main.comment",
            },
            actions1: {
                label: "main.actions",
                callback: this.renderActionCell.bind(this),
                hideLabel: true,
                cantSort: true,
                size: "32px",
            },
            actions2: {
                label: "main.actions",
                callback: this.renderInCell.bind(this),
                hideLabel: true,
                cantSort: true,
                size: "32px",
            },
        };

        this.state = {
            ...this.state,
        };
    }

    async deletePrice(id) {
        const { loadPrices } = this.props;
        this._helper.showLoading();

        await this._request.priceLists.delete(id);
        await loadPrices();

        this._helper.hideLoading();
    }

    async createNewPrice(info) {
        const { loadPrices, onInPrice } = this.props;
        await loadPrices();
        onInPrice(info, "edit");
    }

    async downloadXlsx({ id, validity }) {
        this._helper.showLoading();
        const resp = await this._request.priceCategories.getPriceById(id);
        const data = resp?.data || [];
        let prices = { 0: [] };
        if (data.length > 0)
            prices = { 0: data[0] };
        this._helper.hideLoading();

        this.props.downloadXlsx(prices[0].items, validity);
    }

    renderStatusCell(value, it, info) {
        const { renderStatus } = this.props;
        return renderStatus(value);
    }

    renderInCell(value, it, info) {
        const { onInPrice } = this.props;
        return <ButtonIcon type="stroke" name="arrow" onClick={onInPrice.bind(this, info, "view")} />;
    }

    renderActionCell(value, it, info) {
        const { openDialog } = this.props;
        let actionsItems = [
            { name: "price.download", onClick: this.downloadXlsx.bind(this, info) },
            { name: "expenses.print", onClick: null },
        ];
        if (info.status === 1) {
            actionsItems = [
                { name: "price.createPrice", onClick: openDialog.bind(this, "newPrice", "old", info, this.createNewPrice.bind(this)) },
                { name: "price.download", onClick: this.downloadXlsx.bind(this, info) },
                { name: "expenses.print", onClick: null },
            ];
        } else if (info.status === 2) {
            actionsItems = [
                { name: "main.edit", onClick: this.props.onInPrice.bind(this, info, "edit") },
                { name: "price.download", onClick: this.downloadXlsx.bind(this, info) },
                { name: "expenses.print", onClick: null },
                { name: "client.delete", onClick: this.deletePrice.bind(this, info.id) },
            ];
        }

        return (<ButtonIconSelect
            translate={true}
            items={actionsItems}
        />);
    }

    render() {
        const { listPrices, openDialog } = this.props;

        return (
            <div className="priceLists flex1 flex col gap16">
                <div className="flex between">
                    <div className="flex gap16">
                        <div>
                            <div className="text blockTitle">{this.tr("price.prices")}</div>
                        </div>
                    </div>
                    <div className="buttons flex gap16">
                        <Button
                            type={"secondary"}
                            size={"small"}
                            label={"price.downloadPrice"}
                            icon={<UploadIcon />}
                            onClick={openDialog.bind(this, "fileUpload", {
                                title: "price.downloadCSV",
                                header: true,
                                accept: ".csv"
                            })}
                        />
                        <Button
                            type={"secondary"}
                            size={"small"}
                            label={"price.newPrice"}
                            onClick={openDialog.bind(this, "newPrice", "new", {}, this.createNewPrice.bind(this))}
                            icon={<PlusIcon />}
                        />
                    </div>
                </div>
                <div className="flex flex1">
                    <Table
                        map={this.tableMap}
                        items={listPrices}
                    />
                </div>
            </div>
        );
    }
}

